import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "../types";
import { SubscriptionService } from "../subscription.service";
import { environment } from "@environments/environment";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
})
export class MainComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.subscription_id = params["subscription_id"] || "";
      if (!this.subscription_id) {
        this.subscriptionService
          .getSubscriptionIds()
          .subscribe((subscriptions: Subscription[]) => {
            this.subscriptions = subscriptions;
            if (
              this.subscriptions.length === 1 &&
              !(environment as any).products["kbin"]
            ) {
              this.setSubscription(this.subscriptions[0].subscription_id);
            }
          });
      }
    });
  }

  subscriptions: Subscription[] = [];

  setSubscription(subscription_id: string) {
    this.router.navigate(["/"], {
      queryParams: {
        subscription_id,
      },
      queryParamsHandling: "merge",
    });
    this.subscription_id = subscription_id;
  }

  subscription_id: string = "";
}
